var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 47 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M46 23.5C46 11.074 35.926 1 23.5 1S1 11.074 1 23.5 11.074 46 23.5 46H46l-6.59-6.59A22.43 22.43 0 0 0 46 23.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Info_svg__a)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M23.5 35.823c6.806 0 12.323-5.517 12.323-12.324 0-6.806-5.517-12.323-12.324-12.323-6.806 0-12.323 5.517-12.323 12.323 0 6.807 5.517 12.324 12.323 12.324"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EBF5FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M23.5 29.125V23.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M23.503 21.275c.733 0 1.435-.644 1.4-1.4-.033-.759-.615-1.4-1.4-1.4-.732 0-1.434.644-1.4 1.4.034.759.615 1.4 1.4 1.4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Info_svg__a",
    x1: 17,
    x2: 31,
    y1: 15,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgInfo;